<template>
  <div class="image-btn">
    <v-tooltip top  v-if="icon && !hideTooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="selectFile" color="primary" v-bind="attrs" v-on="on" icon><v-icon>mdi-image-plus</v-icon></v-btn>
      </template>
      <span>{{$t('imagecropper_add_a_picture')}}</span>
    </v-tooltip>
    <div v-if="hideTooltip" class="d-flex flex-column justify-center align-center cursor-pointer">
      <v-btn @click="selectFile" color="primary" icon x-large>
        <v-icon>mdi-image-plus</v-icon>
      </v-btn>
      <span class="branding-label">{{ $t('imagecropper_upload_image') }}</span>
    </div>
    <v-btn v-if="!icon && !hideTooltip" @click="selectFile" :class="'inset'" color="primary">{{$t('imagecropper_upload_image')}}</v-btn>
    <input :ref="`input-${inputKey}`" :id="inputKey" @change="setImage" type="file" name="image" accept="image/*">
    <v-dialog scrollable width="700" v-model="openModal">
      <v-card>
        <v-card-title class="headline">{{$t('imagecropper_image_upload')}}</v-card-title>
        <v-card-text>
          <vue-cropper
            :ref="`cropper-${inputKey}`"
            :src="this.src"
            :viewMode="1"
            :containerStyle="containerStyle"
            :zoomable="false"
          >
          </vue-cropper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="close" :disabled="uploading">{{$t('close')}}</v-btn>
          <v-btn text @click="save" color="primary" :loading="uploading">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import { mapGetters } from 'vuex'

export default {
  name: 'ImageCropper',
  props: ['src', 'icon', 'input-key', 'hide-tooltip'],
  computed: mapGetters(['uploading']),
  components: {
    VueCropper
  },
  data () {
    return {
      openModal: false,
      type: null,
      croppedImg: null,
      containerStyle: {
        width: '100%',
        'max-height': '450px'
      }
    }
  },

  methods: {
    cropImage () {
      if (this.$refs[`cropper-${this.inputKey}`]) {
        this.croppedImg = this.$refs[`cropper-${this.inputKey}`].getCroppedCanvas().toDataURL(this.type)
      }
    },

    async save () {
      // upload
      this.cropImage()
      const res = await this.$store.dispatch('uploadPicture', this.croppedImg)
      this.$emit('image-upload', res.file)
      this.close()
    },

    close () {
      this.openModal = false
    },

    setImage (e) {
      const file = e.target.files[0]
      if (!file) {
        return
      }
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      this.type = file.type
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = async (event) => {
          this.imgSrc = event.target.result
          if (this.type === 'image/gif') {
            const res = await this.$store.dispatch('uploadPicture', this.imgSrc)
            this.$emit('image-upload', res.file)
          } else {
            this.openModal = true
            setTimeout(() => {
              this.$refs[`cropper-${this.inputKey}`].replace(event.target.result)
            }, 200)
          }
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },

    selectFile () {
      const input = document.getElementById(this.inputKey)

      input.click()
    }
  }
}
</script>

<style lang="sass" scoped>

.image-btn
  position: relative

input
  display: none

</style>
